import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/options-saas/app/(marketing)/gex-mcp/client.tsx");
